import { CouponConfiguration } from './coupon-configuration.model';
import { CustomerStatus } from './customer-status.model';
import { CustomerTestGroup } from './customer-test-group.model';
import { LockStatus } from './lock-status.enum';
import { Settings } from './settings.model';
import { VerificationStatus } from './verification-status.enum';
import { Regulation } from '../../shared/models/regulation.model';

export interface Customer extends CustomerLimited {
  userId: string;
  name: string;
  phoneNumber: string;
  docId: string;
  docDate; String
  nrbs: string[];
  details: OmegaPersonalData;
  settings: Settings;
  couponConfiguration: CouponConfiguration;
  verificationStatus: VerificationStatus;
  testGroup: CustomerTestGroup;
  hasConfiguredAutomaticPayments: boolean;
  paykaFinancialData: PaykaFinancialData;
  forename: string;
  surname: string;
  customerBillersCount?: number;
  defermentsCount?: number;
  defermentsAmount?: number;
}

export interface PaykaFinancialData {
  limitNettoFree: number;
  limitNettoUsed: number;
  limitNettoTotal: number;
  limitNettoPotential: number;
  toPayOverdue: number;
  toPayMonth: number;
  toPayTotal: number;
  numberOfOutstanding: number;
  agreementsCount: number;
  agreementsSum: number;
  activeAgreementsCount: number;
}

export interface CustomerLimited {
  customerId: string;
  email: string;
  displayName: string;
  lockStatus: LockStatus;
  customerStatus: CustomerStatus;
  forename: string;
  surname: string;
  nick: string;
  accountStatus: AccountStatus;
}

export enum AccountStatus {
  LIGHT = 'LIGHT',
  MEDIUM = 'MEDIUM',
  UPGRADING = 'UPGRADING'
}

export enum UpgradeAccountStatus {
  UPDATED = 'Updated',
  CLIENT_ID_UNKONWN = 'ClientIdUnknown',
  PESEL_MISMATCH = 'PeselMismatch',
  FAILED = 'Failed'
}

export interface OmegaPersonalData {
  firstname: string;
  lastname: string;
  nrbs: string[];
  returnNrb: string;
  consents: Regulation[];
  docId: string;
  docDate: string;
  customerBillersCount?: number;
  defermentsCount?: number;
  defermentsAmount?: number;
}
